import { render, staticRenderFns } from "./maYiPayRule.vue?vue&type=template&id=590565de&scoped=true&"
import script from "./maYiPayRule.vue?vue&type=script&lang=js&"
export * from "./maYiPayRule.vue?vue&type=script&lang=js&"
import style0 from "./maYiPayRule.vue?vue&type=style&index=0&id=590565de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590565de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590565de')) {
      api.createRecord('590565de', component.options)
    } else {
      api.reload('590565de', component.options)
    }
    module.hot.accept("./maYiPayRule.vue?vue&type=template&id=590565de&scoped=true&", function () {
      api.rerender('590565de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/maYiPayRule.vue"
export default component.exports